import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Badge from 'src/common/ui-kit/Badge'
import NumericField from 'src/common/ui-kit/NumericField/NumericField'

interface CustomPercentageProps {
  value: number | null
  onChange: (value: number | null) => void
  active?: boolean
  onClick?: () => void
  onBlur?: () => void
  isNegative: boolean
  isDynamic: boolean
}

const MAX_PERCENTAGE = 100
const MIN_PERCENTAGE = 0

const CustomPercentage: React.FC<CustomPercentageProps> = ({
  value,
  active,
  isNegative,
  onClick,
  onChange,
  onBlur,
  isDynamic,
}) => {
  const { t } = useTranslation('trade')

  useEffect(() => {
    if (!value) return

    if ((isDynamic || isNegative) && value > MAX_PERCENTAGE) {
      onChange(MAX_PERCENTAGE)
    }
  }, [isDynamic, isNegative, onChange, value])

  const handleChange = (newValue: number) => {
    if (newValue < MIN_PERCENTAGE) {
      onChange(MIN_PERCENTAGE)
    } else if (newValue > MAX_PERCENTAGE && isDynamic) {
      onChange(MAX_PERCENTAGE)
    } else {
      onChange(newValue)
    }
  }

  const isEmpty = value === null

  return (
    <Badge
      color='secondary'
      size='sm'
      active={active}
      className='text-main-accent'
      onClick={onClick}
    >
      <NumericField
        variant='text'
        className='w-24'
        size='sm'
        value={value || 0}
        displayValue={isEmpty ? '' : null}
        onChange={handleChange}
        onBlur={onBlur}
        type='number'
        style={{ width: '45px', height: '20px' }}
        inputProps={{
          placeholder: t('customPercentage.placeholder'),
          style: {
            width: '45px',
            height: '20px',
            backgroundColor: 'transparent',
            padding: 0,
          },
        }}
        hideError
      />
      <span>{t('customPercentage.percentageSymbol')}</span>
    </Badge>
  )
}

export default CustomPercentage
